import "./ShortUserInfo";
import "./AddToBrowserButton";

document.addEventListener("load", () => {
  console.log("The page is loaded");
});
